// Auto-generated by scripts/generate-icons.ts - DO NOT EDIT
// Generated: 2026-03-21T11:08:57.354Z

export const ICON_NAMES = [
  "arrow-right",
  "arrow-left",
  "arrow-up",
  "arrow-down",
  "chevron-right",
  "chevron-left",
  "chevron-up",
  "chevron-down",
  "bars-3",
  "x-mark",
  "plus",
  "minus",
  "check",
  "trash",
  "pencil",
  "arrow-path",
  "arrow-down-tray",
  "arrow-up-tray",
  "clipboard-document",
  "clipboard-document-check",
  "link",
  "magnifying-glass",
  "adjustments-horizontal",
  "cog-6-tooth",
  "funnel",
  "ellipsis-horizontal",
  "ellipsis-vertical",
  "squares-2x2",
  "list-bullet",
  "bookmark",
  "heart",
  "star",
  "bell",
  "eye",
  "eye-slash",
  "envelope",
  "phone",
  "chat-bubble-left",
  "chat-bubble-left-right",
  "paper-airplane",
  "video-camera",
  "microphone",
  "shopping-cart",
  "shopping-bag",
  "credit-card",
  "receipt-refund",
  "tag",
  "currency-dollar",
  "play",
  "pause",
  "stop",
  "speaker-wave",
  "speaker-x-mark",
  "photo",
  "camera",
  "document",
  "folder",
  "check-circle",
  "x-circle",
  "exclamation-triangle",
  "exclamation-circle",
  "information-circle",
  "question-mark-circle",
  "shield-check",
  "lock-closed",
  "lock-open",
  "face-frown",
  "user",
  "user-circle",
  "users",
  "user-group",
  "identification",
  "academic-cap",
  "briefcase",
  "clock",
  "calendar",
  "calendar-days",
  "map-pin",
  "map",
  "globe-alt",
  "home",
  "building-office",
  "chart-bar",
  "chart-pie",
  "presentation-chart-line",
  "arrow-trending-up",
  "arrow-trending-down",
  "sun",
  "moon",
  "sparkles",
  "fire",
  "bolt",
  "wifi",
  "signal",
  "qr-code",
  "finger-print",
  "gift",
  "light-bulb",
  "puzzle-piece",
  "rocket-launch",
  "wrench",
  "book-open",
  "rss",
  "trophy",
  "youtube",
  "telegram",
  "vk",
] as const;

export type IconName = (typeof ICON_NAMES)[number];

const iconNameSet = new Set<string>(ICON_NAMES);

export function isValidIconName(name: string): name is IconName {
  return iconNameSet.has(name);
}
